import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TRANSLATIONFILE } from '@core/utils/const';
import { MobileConfigService } from './mobile/mobile-config.service';

@Injectable({
    providedIn: 'root'
})
export class MobileTranslationLoader implements TranslateLoader {
    private http = inject(HttpClient);
    private mobileConfig = inject(MobileConfigService);

    getTranslation(lang: string): Observable<any> {
        const domains = TRANSLATIONFILE;

        // Su mobile, usa un approccio diverso per caricare le traduzioni
        if (this.mobileConfig.isMobile()) {
            return this.loadMobileTranslations(lang, domains);
        } else {
            return this.loadWebTranslations(lang, domains);
        }
    }

    private loadWebTranslations(lang: string, domains: string[]): Observable<any> {
        const translationObservables = domains.map(domain => {
            return this.http.get(`/assets/i18n/${lang}/${domain}.json`).pipe(
                catchError(error => {
                    return of({}); // Ritorna un oggetto vuoto in caso di errore
                })
            );
        });

        return forkJoin(translationObservables).pipe(
            map((translations: any[]) => {
                return translations.reduce((acc: any, translation) => {
                    return { ...acc, ...translation };
                }, {});
            })
        );
    }

    private loadMobileTranslations(lang: string, domains: string[]): Observable<any> {
        // Su mobile, i file sono serviti da assets/
        const translationObservables = domains.map(domain => {
            // Usa il percorso corretto per Capacitor
            const url = `./assets/i18n/${lang}/${domain}.json`;

            return this.http.get(url).pipe(
                catchError(error => {
                    return of({}); // Ritorna un oggetto vuoto in caso di errore
                })
            );
        });

        return forkJoin(translationObservables).pipe(
            map((translations: any[]) => {
                return translations.reduce((acc: any, translation) => {
                    return { ...acc, ...translation };
                }, {});
            }),
            catchError(error => {
                return of({}); // Fallback a un oggetto vuoto
            })
        );
    }
}